const __WEBPACK_NAMESPACE_OBJECT__ = SharedDependencies.ServiceTitan.Anvil2['task-hub'];